export default __webpack_public_path__ + "navigation-examples-route-init-thumbnail-v1-480-250fb7e5d59309b32b6259819a11c085.png";